export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Our work', href: '#work' },
  { label: 'How it works', href: '#process' },
  { label: 'About', href: '#about' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#estimate' },
];
